import React from "react"; 
import imgs from "../../../../../../assets/images/imgs";
import { NavLink, useNavigate, useParams } from "react-router";
import { addToHistory } from "../../../../../../state/reducers/historyReducer";
import { useDispatch, useSelector } from "react-redux";
import { Chip } from "@mui/material";
import "./StudentCourseCard.css";  //used css only for labels and status badge
import { Tooltip } from "react-tooltip";
import { toTitleCase } from "../../../../../../utils/utlis";

const StudentCourseCard = ({ course }) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { teacher_id } = useParams();

  const globalState = useSelector((state) => state.globalState);
  const onGoToCourse = () => {
    const targetPath = isRequested
      ? `/course/${course?.course_id}/view`
      : `/course/${course?.course_id}`;
    navigate(targetPath, {
      state: {
        course,
      },
    });
    dispatch(addToHistory("/dashboard/my-courses/active-courses"));
  };
  const isFavourite = course?.status === "Favourite";
  const isRequested = course?.status === "Pending";
  const isActive = course?.status === "Active";
  const isCompleted = course?.status === "Completed";
  const isExpired = course?.status === "Expired";
  return (
    <>
      <div className="StudentCourseCard-main-container">
        <div
          className="studentDashboar-Suggested-Courses-folder"
          id="studentCourseCard-folder"
        >
          <div
            className="studentDashboar-Suggested-Courses-image"
            onClick={onGoToCourse}
          >
            <img src={course?.image_url || imgs.jpg.course_demo_image} alt="" />
            {/* STATUS BADGE */}

            {course?.status &&
              globalState.enabled_modules?.includes("marketplace") && (
                <div
                  className={`course-status-badge status-${course?.status
                    ?.toLowerCase()
                    .replace(/\s+/g, "-")}`}
                >
                  {/* {course?.status} */}
                  {course?.status === "Pending" ? "Requested" : course?.status}
                </div>
              )}
          </div>
          <div className="studentDashboar-Suggested-Courses-profile-folder">
            <>
              <NavLink to={`/Teacher/${course?.teacher}`}>
                <div className="studentDashboar-Suggested-Courses-profile">
                  <div className="studentDashboar-profile-image">
                    <img
                      src={course?.ai_avatar ?? imgs.png.tearcher_profile_image}
                      alt=""
                    />
                  </div>
                  <div className="studentDashboar-Suggested-Courses-profile-title">
                    {/* <h2 className="tudentDashboar-profile-card-title ">
                      {course.teacher_name} */}
                                      <h2 className="tudentDashboar-profile-card-title" data-tooltip-id={course?.teacher_name?.length > 25 ? "teacher-name" : ""} data-tooltip-content={course?.teacher_name}>
                  {course?.teacher_name.slice(0, 25) + (course?.teacher_name.length > 25 ? "..." : "")}
                    </h2>
                    <p>Teacher</p>
                  </div>
                </div>
                     <Tooltip
                                                      id="teacher-name"
                                                      place="top"
                                                      type="light"
                                                      effect="float"
                                                    />
              </NavLink>
              {/* <div className="Invited">
              {course?.source && course?.source === "Invited" && (
                <Chip label={"Enrolled"} />
              )}
            </div>
            <div className="Enrolled-btn">
              {course?.source && course?.source === "Enrolled" && (
                <Chip label={course?.source} />
              )}
            </div> */}
            </>
          </div>
          <p className="studentDashboar-profile-course-name">
            {typeof course?.subject === "string"
              ? toTitleCase(course.subject)
              : course?.subject
                ? toTitleCase(Object.values(course.subject)[0])
                : ""}
          </p>
          <div className="studentDashboard-course-name-rating">
            <h2
              className="studentDashboar-profile-course-title"
              onClick={onGoToCourse}
              {...(course?.name?.length > 20 && {
                "data-tooltip-id": "course-name",
                "data-tooltip-content": course?.name,
              })}
            >
              {course?.name?.length > 20
                ? course.name.slice(0, 20) + "..."
                : course?.name}
            </h2>

            {globalState.enabled_modules?.includes("marketplace") &&
              course?.competitive_exam === null && (
                <div className="studentDashboar-Suggested-Courses-profile-rate !flex-row">
                  <a>
                    <i className="fa-solid fa-star"></i>
                  </a>
                  <p className="rate">{course?.average_course_rating || "0"}</p>
                  <p className="number">({parseInt(course?.rating_count || 0)})</p>
                </div>
              )}
          </div>
          <div className="studentDashboar-profile-btn-folder">
            <button type="button" disabled={isRequested} onClick={onGoToCourse}>
              {isRequested && <i className="fa-solid fa-circle-check" />}
              {isRequested && "Request Sent"}
              {isActive && "Go to course"}
              {(isFavourite || isCompleted || isExpired) && "View Course"}
            </button>
          </div>
        </div>
      </div>
      <Tooltip id="course-name" place="top" type="light" effect="float" />
    </>
  );
};

export default StudentCourseCard;